import peace from "../../../assets/images/icons/peacevillage.png";

const PdfRenderComponent = ({ relativesList, userDatas, recommend1, recommend2, emergency, formName }) => {
    return (
        <div className="pdf-container" style={{
            backgroundColor: 'white',
            padding: '20px',
            width: '210mm',
            minHeight: '297mm'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src={peace} className="peace-image " alt="Peace Village" />
                <h4 className='dialysis-head'>{formName}</h4>
                <div></div>
            </div>
            <div className="row side-head">
                <div className="col-12">
                    <hr className="lines" />
                </div>
            </div>
            {userDatas && <div className='dialysis-formelements'>
                <div className='row'>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                First Name
                            </label>
                            <div className='input1'>
                                {userDatas?.firstname}
                            </div>
                        </div>
                        <div className='input-container'>
                            <label>
                                Contact no
                            </label>
                            <div className='input1'>
                                {userDatas?.phone?.mobile_number}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Last Name
                            </label>
                            <div className='input1'>
                                {userDatas?.lastname}
                            </div>
                        </div>
                        <div className='input-container'>
                            <label>
                                Age / Date of Birth
                            </label>
                            <div className='input1'>
                                {userDatas?.age} - {userDatas?.dob}
                            </div>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Gender
                            </label>
                            <div className='input1'>
                                {userDatas?.gender}
                            </div>
                        </div>
                        <div className='input-container'>
                            <label>
                                House Name / Apartment Name
                            </label>
                            <div className='input1'>
                                {userDatas?.house_name || userDatas.apartment_no}
                            </div>
                        </div>
                    </div>
                    <div className='col-2'>
                        <div className='dialysis-profile'>
                            <div className="profile-container">
                                <div className="uploaded">
                                    <img
                                        src={userDatas?.img_url}
                                        alt="Hospital Picture"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className='input-container'>
                            <label>
                                Location
                            </label>
                            <div className='input1'>
                                {userDatas?.location}
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className='input-container'>
                            <label>
                                LandMark
                            </label>
                            <div className='input1'>
                                {userDatas?.landmark}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Post / Pincode
                            </label>
                            <div className='input1'>
                                {userDatas?.pincode}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Residing Panchayath
                            </label>
                            <div className='input1'>
                                {userDatas?.panchayath}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                City
                            </label>
                            <div className='input1'>
                                {userDatas?.city}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                District
                            </label>
                            <div className='input1'>
                                {userDatas?.province}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                State
                            </label>
                            <div className='input1'>
                                {userDatas?.state}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Country
                            </label>
                            <div className='input1'>
                                {userDatas?.country}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Occupation
                            </label>
                            <div className='input1'>
                                {userDatas?.occupation}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Income
                            </label>
                            <div className='input1'>
                                {userDatas?.income}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                ID Card Type
                            </label>
                            <div className='input1'>
                                {userDatas?.identitycard.value}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                ID Card Number
                            </label>
                            <div className='input1'>
                                {userDatas?.identitynumber}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Insurance Provider
                            </label>
                            <div className='input1'>
                                {userDatas?.insuranceprovider}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Insurance Number
                            </label>
                            <div className='input1'>
                                {userDatas?.insurancenumber}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Distance to reach PV?
                            </label>
                            <div className='input1'>
                                {userDatas?.distance}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row side-head">
                    <div className="col-2">
                        <label>Family Details</label>
                    </div>
                    <div className="col-10">
                        <hr className="lines" />
                    </div>
                </div>
                {relativesList?.length > 0 && (
                    <div style={{ width: "90%", margin: "auto" }}>
                        <div className="row">
                            <div className="row">
                                <div className="col-3 relative-table t2-color">
                                    Name
                                </div>
                                <div className="col-2 relative-table t2-color">
                                    Relation
                                </div>
                                <div className="col-3 relative-table t2-color">
                                    Contact
                                </div>
                                <div className="col-2 relative-table t2-color">
                                    Occupation
                                </div>
                                <div className="col-2 relative-table t2-color">
                                    Income
                                </div>
                            </div>
                            {relativesList?.map((item, index) => {
                                return (
                                    <>
                                        <div className="row">
                                            <div className="col-3 relative2-table" style={{ textTransform: 'capitalize' }}>
                                                {item.name}
                                            </div>
                                            <div className="col-2 relative2-table" style={{ textTransform: 'capitalize' }}>
                                                {item.relation}{" "}
                                            </div>
                                            <div className="col-3 relative2-table">
                                                {item.contact !== '91' ? item.contact : ""}
                                            </div>
                                            <div className="col-2 relative2-table" style={{ textTransform: 'capitalize' }}>
                                                {item.occupation}
                                            </div>
                                            <div className="col-2 relative2-table"   >
                                                {item.income}
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>
                )}
                <div className="row side-head">
                    <div className="col-2">
                        <label>Medical Information</label>
                    </div>
                    <div className="col-10">
                        <hr className="lines" />
                    </div>
                </div>
                {formName === 'Palliative Application Form' || formName === 'Physiotherapy Application Form' &&
                    <div className="row">
                        <div className='col-8'>
                            <div className='input-container'>
                                <label>
                                    Do you have any current medical conditions? [Yes/No] If yes, please specify
                                </label>
                                <div className='input1'>
                                    {userDatas?.med_information}
                                </div>
                            </div>
                        </div>
                        <div className='col-4'>
                            <div className='input-container'>
                                <label>
                                    Upload Prescription
                                </label>
                                <div className='input1'>
                                    Uploaded
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {formName === 'Dialysis Application Form' &&
                    <>
                        <div className="row" style={{ marginBottom: '20px' }}>
                            <div className='col-4'>
                                <div className='input-container'>
                                    <label>
                                        What is the total expense incurred on medication?
                                    </label>
                                    <div className='input1'>
                                        {userDatas?.med_expense}
                                    </div>
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='input-container'>
                                    <label>
                                        Have you undergone a kidney transplantation?
                                    </label>
                                    <div className='input1'>
                                        {userDatas?.prev_kidney_transplant}
                                    </div>
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='input-container'>
                                    <label>
                                        Have you undergone a blood transfusion?
                                    </label>
                                    <div className='input1 top-margin'>
                                        {userDatas?.prev_blood_transfusion}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-4'>
                                <div className='input-container'>
                                    <label>
                                        Duration of dialysis treatment
                                    </label>
                                    <div className='input1'>
                                        {userDatas?.prev_dialysis}
                                    </div>
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='input-container'>
                                    <label>
                                        Upload Prescription
                                    </label>
                                    <div className='input1'>
                                        Uploaded
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {formName === 'Palliative Application Form' &&
                    <>
                        <div className="row side-head">
                            <div className="col-2">
                                <label> Comorbidities </label>
                            </div>
                            <div className="col-10">
                                <hr className="lines" />
                            </div>
                        </div>
                        {userDatas?.comorbidConditions?.map((condition, index) => (
                            <div className='row' key={index}>
                                <div className='col-6'>
                                    <div className='input-containersp' style={{ height: '45px', marginBottom: '10px' }}>
                                        <div className='input1'>
                                            {condition}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                }
                <div className="row side-head">
                    <div className="col-2">
                        <label>Recommendation</label>
                    </div>
                    <div className="col-10">
                        <hr className="lines" />
                    </div>
                </div>
                <div className="row">
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Name
                            </label>
                            <div className='input1'>
                                {recommend1?.name}
                            </div>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Designation
                            </label>
                            <div className='input1'>
                                {recommend1?.relation}
                            </div>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Contact no
                            </label>
                            <div className='input1'>
                                {recommend1?.contact}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Name
                            </label>
                            <div className='input1'>
                                {recommend2?.name}
                            </div>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Designation
                            </label>
                            <div className='input1'>
                                {recommend2?.relation}
                            </div>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='input-container'>
                            <label>
                                Contact no
                            </label>
                            <div className='input1'>
                                {recommend2?.contact}
                            </div>
                        </div>
                    </div>
                </div>
                {formName === 'Dialysis Application Form' &&
                    <div className='row'>
                        <div className='col-8'>
                            <div className='input-container'>
                                <label>
                                    Recommmendation
                                </label>
                                <div className='input1'>
                                    Uploaded
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row side-head">
                    <div className="col-2">
                        <label>Referral Information</label>
                    </div>
                    <div className="col-10">
                        <hr className="lines" />
                    </div>
                </div>
                <div className="row">
                    <div className='col-6'>
                        <div className='input-container'>
                            <label>
                                Name of physician or health provider
                            </label>
                            <div className='input1'>
                                {userDatas?.referral_name}
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='input-container'>
                            <label>
                                Referral Consent
                            </label>
                            <div className='input1'>
                                Uploaded
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row side-head">
                    <div className="col-2">
                        <label>Emergency Contact</label>
                    </div>
                    <div className="col-10">
                        <hr className="lines" />
                    </div>
                </div>
                <div className="row">
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Name
                            </label>
                            <div className='input1'>
                                {emergency?.name}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Relation
                            </label>
                            <div className='input1'>
                                {emergency?.relation}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Contact no
                            </label>
                            <div className='input1'>
                                {emergency?.contact}
                            </div>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='input-container'>
                            <label>
                                Secondary contact no
                            </label>
                            <div className='input1'>
                                {emergency?.secondary_contact}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div >
    );
};

export default PdfRenderComponent;